var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"text-center",attrs:{"title":"Application Form"}},[_c('h2',[_vm._v("Please "),_c('a',{attrs:{"href":"/files/MFT Grant Application - 2023.doc"}},[_vm._v("Download")]),_vm._v(" the application form here.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }